import React, { useState, useEffect } from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import {
  AgeDropDownList,
  AgeDropDownType,
  AnnualIncomeDropDownList,
  AnnualIncomeDropDownType,
  AssetsDropDownList,
  AssetsDropDownType,
  InvestmentStartYearDropDownList,
  InvestmentStartYearDropDownType,
  NotSelected,
  UserTag,
  ageList,
  annualIncomeList,
  assetsList,
  getUnit,
  investmentStartYearList,
} from 'components/features/utils/personaChart';

type InvestmentProductsList = {
  tag: UserTag;
  name: string;
  text: string;
};

const ageDropDownList = [
  { type: -1, label: '選択してください', tag: null },
  ...ageList.filter(list => list.filterFlag === true),
  { type: 8, label: '80代以上', tag: 1108 },
] as AgeDropDownList[];

const annualIncomeDropDownList = [
  { type: -1, labelFrom: '選択してください', labelTo: '', tag: null },
  ...annualIncomeList.filter(list => list.filterFlag === true),
].filter(list => list.tag !== 1401) as AnnualIncomeDropDownList[];

const assetsDropDownList = [
  { type: -1, labelFrom: '選択してください', labelTo: '', tag: null },
  ...assetsList.filter(list => list.filterFlag === true),
] as AssetsDropDownList[];

const investmentStartYearDropDownList = [
  { type: -1, label: '選択してください', tag: null },
  ...investmentStartYearList,
] as InvestmentStartYearDropDownList[];

// チェックボックス
const investmentProductsList = [
  {
    tag: 2101,
    name: '国内株式30％以上',
    text:
      '資産総額のうち30％以上の金額を「国内株式」に投資している商品で保有している',
  },
  {
    tag: 2102,
    name: '先進国株式30％以上',
    text:
      '資産総額のうち30％以上の金額を「先進国株式」に投資している商品で保有している',
  },
  {
    tag: 2109,
    name: '現金30％以上',
    text: '資産総額のうち30％以上の金額を現金で保有している',
  },
  {
    tag: 2201,
    name: 'NISA',
    text: '保有銘柄の半分以上がNISA口座で運用',
  },
  {
    tag: 2202,
    name: '確定拠出年金',
    text: '保有銘柄の半分以上が確定拠出年金口座で運用',
  },
] as InvestmentProductsList[];

export const PersonaChartFilterEditModal = ({
  hide,
  isShow,
  chartAssetFilter,
  setChartAssetFilter,
  type,
}: {
  isShow: boolean;
  hide: () => void;
  chartAssetFilter: number[];
  setChartAssetFilter: React.Dispatch<React.SetStateAction<number[]>>;
  type: string;
}) => {
  const selectedAgeTag = chartAssetFilter.find(
    num => num !== null && 1101 <= num && num <= 1110
  );
  const selectedAnnualIncomeTag = chartAssetFilter.find(
    num => num !== null && 1300 <= num && num <= 1400
  );
  const selectedAssetTag = chartAssetFilter.find(
    num => num !== null && 1200 <= num && num <= 1239
  );
  const selectedinvestmentStartYearTag = chartAssetFilter.find(
    num => num !== null && 1500 <= num && num <= 1506
  );
  const selectedInvestmentProductsTag = chartAssetFilter.filter(
    num => num !== null && 2101 <= num && num <= 2202
  );

  const ageTagItem = ageDropDownList.find(list => list.tag === selectedAgeTag);
  const annualIncomeTagItem = annualIncomeDropDownList.find(
    list => list.tag === selectedAnnualIncomeTag
  );
  const assetsTagItem = assetsDropDownList.find(
    list => list.tag === selectedAssetTag
  );
  const investmentStartYearTagItem = investmentStartYearDropDownList.find(
    list => list.tag === selectedinvestmentStartYearTag
  );

  const selectedAge = ageTagItem !== undefined ? ageTagItem.type : -1;
  const selectedAnnualIncome =
    annualIncomeTagItem !== undefined ? annualIncomeTagItem.type : -1;
  const selectedAssets = assetsTagItem !== undefined ? assetsTagItem.type : -1;
  const selectedInvestmentStartYear =
    investmentStartYearTagItem !== undefined
      ? investmentStartYearTagItem.type
      : -1;
  // const selectedInvestmentProducts = chartAssetFilter.investmentProducts;
  const selectedInvestmentProducts = selectedInvestmentProductsTag;

  // セレクトボックス
  const [age, setAge] = useState<AgeDropDownType | NotSelected>(selectedAge);
  const [annualIncome, setAnnualIncome] = useState<
    AnnualIncomeDropDownType | NotSelected
  >(selectedAnnualIncome);
  const [assets, setAssets] = useState<AssetsDropDownType | NotSelected>(
    selectedAssets
  );
  const [investmentStartYear, setInvestmentStartYear] = useState<
    InvestmentStartYearDropDownType | NotSelected
  >(selectedInvestmentStartYear);

  const [investmentProducts, setinvestmentProducts] = useState<UserTag[]>(
    selectedInvestmentProducts
  );

  useEffect(() => {
    setAge(selectedAge);
    setAnnualIncome(selectedAnnualIncome);
    setAssets(selectedAssets);
    setInvestmentStartYear(selectedInvestmentStartYear);
    setinvestmentProducts(selectedInvestmentProducts);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartAssetFilter]);

  // セレクトボックス関連
  const ageStates = ageDropDownList.map(list => list.type);
  const ageLabel = (type: AgeDropDownType | NotSelected) => {
    const info = ageDropDownList.find(list => type === list.type);
    if (info !== undefined) {
      const unit =
        info.tag !== null && info.tag !== 1108 ? getUnit(info.tag) : '';
      return `${info.label}${unit}`;
    } else {
      return '';
    }
  };

  const annualIncomeStates = annualIncomeDropDownList.map(list => list.type);
  const annualIncomeLabel = (type: AnnualIncomeDropDownType | NotSelected) => {
    const info = annualIncomeDropDownList.find(list => type === list.type);
    if (info !== undefined) {
      const unit = info.tag !== null ? getUnit(info.tag) : '';
      const label =
        info.tag === null || info.tag === 1400
          ? `${info.labelFrom}${unit}`
          : `${info.labelFrom}～${info.labelTo}${unit}`;
      return label;
    } else {
      return '';
    }
  };

  const assetsStates = assetsDropDownList.map(list => list.type);
  const assetsLabel = (type: AssetsDropDownType | NotSelected) => {
    const info = assetsDropDownList.find(list => type === list.type);
    if (info !== undefined) {
      const unit = info.tag !== null ? getUnit(info.tag) : '';
      const label =
        info.tag === null || info.tag === 1239
          ? `${info.labelFrom}${unit}`
          : `${info.labelFrom}～${info.labelTo}${unit}`;
      return label;
    } else {
      return '';
    }
  };

  const investmentStartYearStates = investmentStartYearDropDownList.map(
    list => list.type
  );
  const investmentStartYearLabel = (
    type: InvestmentStartYearDropDownType | NotSelected
  ) => {
    const info = investmentStartYearDropDownList.find(
      list => type === list.type
    );
    if (info !== undefined) {
      const unit = info.tag !== null ? getUnit(info.tag) : '';
      return `${info.label}${unit}`;
    } else {
      return '';
    }
  };

  const ageFromString = (str: string) => {
    const num = Number(str);
    return num as AgeDropDownType | NotSelected;
  };
  const annualIncomeFromString = (str: string) => {
    const num = Number(str);
    return num as AnnualIncomeDropDownType | NotSelected;
  };
  const assetsFromString = (str: string) => {
    const num = Number(str);
    return num as AssetsDropDownType | NotSelected;
  };
  const investmentStartYearFromString = (str: string) => {
    const num = Number(str);
    return num as InvestmentStartYearDropDownType | NotSelected;
  };

  const toString = (value: number) => `${value.toString()}`;

  const updateChartFilter = () => {
    const ageItem = ageDropDownList.find(list => list.type === age);
    const annualIncomeItem = annualIncomeDropDownList.find(
      list => list.type === annualIncome
    );
    const assetItem = assetsDropDownList.find(list => list.type === assets);
    const investmentStartYearItem = investmentStartYearDropDownList.find(
      list => list.type === investmentStartYear
    );

    const ageTag = ageItem !== undefined ? ageItem.tag : null;
    const annualIncomeTag =
      annualIncomeItem !== undefined ? annualIncomeItem.tag : null;
    const assetTag = assetItem !== undefined ? assetItem.tag : null;
    const investmentStartYearTag =
      investmentStartYearItem !== undefined
        ? investmentStartYearItem.tag
        : null;
    const list = [
      ageTag,
      annualIncomeTag,
      assetTag,
      investmentStartYearTag,
      investmentProducts,
    ] as number[];
    const arr = Object.values(list).flat();
    const filterList = arr.filter(v => v);

    setChartAssetFilter(filterList);
    hide();
  };

  const modalClose = () => {
    setAge(selectedAge);
    setAssets(selectedAssets);
    setinvestmentProducts(selectedInvestmentProducts);
    hide();
  };

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto">
          <div className="flex flex-col">
            <div className="flex flex-row">
              <div className="mt-2 text-base font-bold">ペルソナを変更</div>
              <div
                className="icon-close ml-auto text-gray-500 cursor-pointer"
                onClick={modalClose}
              />
            </div>
            <div className="mt-2 text-sm">
              保有資産の種類や投資方法などを設定することで、自分と似た資産運用をしている人を設定できます。
            </div>
            <div className="mt-3 relative">
              <div className="text-sm font-bold text-bluegray-500">年代</div>
              <div
                className={`flex flex-row overflow-hidden w-full items-center h-10 rounded border mt-1 border-bluegray-400`}>
                <select
                  className={`w-full h-full appearance-none bg-transparent text-base pl-4 cursor-pointer`}
                  value={age}
                  onChange={(e): void => {
                    const result = ageFromString(e.currentTarget.value);
                    setAge(result);
                  }}>
                  {ageStates.map((s, i) => {
                    return (
                      <option key={i} value={toString(s)}>
                        {ageLabel(s)}
                      </option>
                    );
                  })}
                </select>
                <div
                  className={
                    'absolute pointer-events-none flex items-center pr-1'
                  }
                  style={{ right: '6%' }}>
                  <i
                    className={`text-bluegray-400 cursor-pointer icon-chevron-down p-0.5 ml-auto`}
                  />
                </div>
              </div>
            </div>
            <div className="mt-3 relative">
              <div className="text-sm font-bold text-bluegray-500">年収</div>
              <div
                className={`flex flex-row overflow-hidden w-full items-center h-10 rounded border mt-1 border-bluegray-400`}>
                <select
                  className={`w-full h-full appearance-none bg-transparent text-base pl-4 cursor-pointer`}
                  value={annualIncome}
                  onChange={(e): void => {
                    const result = annualIncomeFromString(
                      e.currentTarget.value
                    );
                    setAnnualIncome(result);
                  }}>
                  {annualIncomeStates.map((s, i) => {
                    return (
                      <option key={i} value={toString(s)}>
                        {annualIncomeLabel(s)}
                      </option>
                    );
                  })}
                </select>
                <div
                  className={
                    'absolute pointer-events-none flex items-center pr-1'
                  }
                  style={{ right: '6%' }}>
                  <i
                    className={`text-bluegray-400 cursor-pointer icon-chevron-down p-0.5 ml-auto`}
                  />
                </div>
              </div>
            </div>
            {type === 'AssetsAmount' && (
              <div className="mt-3 relative">
                <div className="text-sm font-bold text-bluegray-500">
                  資産総額
                </div>
                <div
                  className={`flex flex-row overflow-hidden w-full items-center h-10 rounded border mt-1 border-bluegray-400`}>
                  <select
                    className={`w-full h-full appearance-none bg-transparent text-base pl-4 cursor-pointer`}
                    value={assets}
                    onChange={(e): void => {
                      const result = assetsFromString(e.currentTarget.value);
                      setAssets(result);
                    }}>
                    {assetsStates.map((s, i) => {
                      return (
                        <option key={i} value={toString(s)}>
                          {assetsLabel(s)}
                        </option>
                      );
                    })}
                  </select>
                  <div
                    className={
                      'absolute pointer-events-none flex items-center pr-1'
                    }
                    style={{ right: '6%' }}>
                    <i
                      className={`text-bluegray-400 cursor-pointer icon-chevron-down p-0.5 ml-auto`}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="mt-3 relative">
              <div className="text-sm font-bold text-bluegray-500">投資歴</div>
              <div
                className={`flex flex-row overflow-hidden w-full items-center h-10 rounded border mt-1 border-bluegray-400`}>
                <select
                  className={`w-full h-full appearance-none bg-transparent text-base pl-4 cursor-pointer`}
                  value={investmentStartYear}
                  onChange={(e): void => {
                    const result = investmentStartYearFromString(
                      e.currentTarget.value
                    );
                    setInvestmentStartYear(result);
                  }}>
                  {investmentStartYearStates.map((s, i) => {
                    return (
                      <option key={i} value={toString(s)}>
                        {investmentStartYearLabel(s)}
                      </option>
                    );
                  })}
                </select>
                <div
                  className={
                    'absolute pointer-events-none flex items-center pr-1'
                  }
                  style={{ right: '6%' }}>
                  <i
                    className={`text-bluegray-400 cursor-pointer icon-chevron-down p-0.5 ml-auto`}
                  />
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="text-sm font-bold text-bluegray-500">タグ</div>
              <div className="">
                {investmentProductsList.map((list, key) => {
                  return (
                    <div className="mb-2" key={key}>
                      <TagItem
                        {...{
                          list,
                          investmentProducts,
                          toggle: (checkTag: UserTag): void =>
                            setinvestmentProducts((prev): typeof prev => {
                              return prev.includes(checkTag)
                                ? prev.filter(tag => tag !== checkTag)
                                : [...prev, checkTag];
                            }),
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            <button
              className="mt-8 bg-tradewell rounded-lg shadow text-white py-2 text-center flex flex-row items-center gap-2 justify-center text-base font-bold"
              onClick={(): void => updateChartFilter()}>
              この条件で設定
            </button>
            <button
              className={`mt-4 p-2 text-bluegray-500 text-center text-sm`}
              onClick={modalClose}>
              キャンセル
            </button>
          </div>
        </div>
      </Modal2>
    </>
  );
};

const TagItem = ({
  list,
  investmentProducts,
  toggle,
}: {
  list: InvestmentProductsList;
  investmentProducts: UserTag[];
  toggle: (checkTag: UserTag) => void;
}) => {
  const isSelected = investmentProducts.includes(list.tag);

  return (
    <div
      className="flex flex-row items-center p-4 bg-bluegray-50 cursor-pointer"
      onClick={() => toggle(list.tag)}>
      <div
        className={`icon-check text-white p-0.5 rounded-sm text-sm ${
          isSelected ? 'bg-blue-700' : 'bg-bluegray-300'
        }`}></div>
      <div className="ml-2">
        <div className="text-base font-bold">{list.name}</div>
        <div className="text-xs">{list.text}</div>
      </div>
    </div>
  );
};
